export const tabs = [
  { id: 'plan', label: 'Audit plan' },
  { id: 'requests', label: 'Evidence requests', count: 6 },
  { id: 'findings', label: 'Findings', count: 6 },
  { id: 'pack', label: 'Audit pack' }
];

export const plan_cards = [
  { label: 'Active audits', value: '3', note: 'External + internal', accent: 'dark' },
  { label: 'Open findings', value: '6', note: 'Of 6 total', accent: 'red' },
  { label: 'Repeat findings', value: '2', note: 'AGSA weighs heavily', accent: 'amber' },
  { label: 'Evidence requests', value: '4', note: 'Outstanding RFIs', accent: 'amber' }
];

export const readiness_rows = [
  { label: 'Supply chain management', value: 62, color: '#c1261a' },
  { label: 'Annual financial statements', value: 76, color: '#c7651f' },
  { label: 'Predetermined objectives', value: 73, color: '#c7651f' },
  { label: 'Compliance with legislation', value: 68, color: '#c7651f' },
  { label: 'Consequence management', value: 70, color: '#c7651f' },
  { label: 'IT general controls', value: 69, color: '#c7651f' }
];

export const engagements = [
  {
    code: 'AUD-01',
    source: 'External (AGSA)',
    stage: 'Fieldwork',
    title: 'AGSA regular audit - FY2025/26',
    owner: 'Auditor-General of South Africa',
    period: '01 Jun - 31 Aug 2026',
    readiness: 71,
    status: 'Ready',
    status_class: 'bg-success-subtle text-success-emphasis',
    topics: ['Supply chain management', 'Annual financial statements', 'Predetermined objectives', '+3']
  },
  {
    code: 'AUD-02',
    source: 'Internal audit',
    stage: 'Reporting',
    title: 'Internal audit - SCM and procurement',
    owner: 'Internal Audit Unit',
    period: '14 Apr - 02 May 2026',
    readiness: 82,
    status: 'Ready',
    status_class: 'bg-success-subtle text-success-emphasis',
    topics: ['Three-quote and bid compliance', 'Deviation and expansion approvals', 'Supplier document validity', '+1']
  },
  {
    code: 'AUD-03',
    source: 'Internal audit',
    stage: 'Planning',
    title: 'POPIA and IT general controls review',
    owner: 'Internal Audit + co-source',
    period: 'Planned - Sep 2026',
    readiness: 58,
    status: 'Gap',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    topics: ['Privileged access reviews', 'Operator / DPA register', 'Backup and recovery', '+1']
  }
];

export const engagement_type_options = [
  'External (AGSA)',
  'Internal audit',
  'Regulatory inspection',
  'Certification audit',
  'Special investigation'
];

export const engagement_status_options = ['Planning', 'Fieldwork', 'Reporting', 'Closed'];
export const request_status_options = ['Requested', 'In progress', 'Submitted', 'Accepted', 'Insufficient'];

export const request_cards = [
  { label: 'Requested', value: '1', note: 'requests', accent: 'dark' },
  { label: 'In progress', value: '1', note: 'requests', accent: 'amber' },
  { label: 'Submitted', value: '1', note: 'requests', accent: 'dark' },
  { label: 'Accepted', value: '2', note: 'requests', accent: 'green' }
];

export const request_rows = [
  {
    ref: 'RFI-014',
    requested: 'RFQ evaluation records - IT renewal and office reno',
    area: 'Supply chain management',
    requested_by: 'AGSA',
    owner: 'SCM Manager',
    due: '30 May 2026',
    status: { label: 'Insufficient', class: 'bg-danger-subtle text-danger-emphasis' },
    note: '2 of 12 evaluation files missing.'
  },
  {
    ref: 'RFI-017',
    requested: 'Conflict-of-interest declarations - bid committee',
    area: 'Supply chain management',
    requested_by: 'AGSA',
    owner: 'HR',
    due: '29 May 2026',
    status: { label: 'Requested', class: 'bg-light text-secondary border border-light' },
    note: 'One panel member outstanding.'
  },
  {
    ref: 'RFI-016',
    requested: 'Privileged access review - Q4 FY25',
    area: 'IT general controls',
    requested_by: 'AGSA',
    owner: 'CISO',
    due: '28 May 2026',
    status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' },
    note: 'Review overdue; being completed.'
  },
  {
    ref: 'RFI-015',
    requested: 'Bank confirmation letters - top 20 suppliers',
    area: 'Annual financial statements',
    requested_by: 'AGSA',
    owner: 'Finance',
    due: '02 Jun 2026',
    status: { label: 'Submitted', class: 'bg-info-subtle text-info-emphasis' },
    note: 'Submitted with evidence pack.'
  },
  {
    ref: 'RFI-018',
    requested: 'Performance information - portfolio of evidence',
    area: 'Predetermined objectives',
    requested_by: 'AGSA',
    owner: 'Strategy and M&E',
    due: '05 Jun 2026',
    status: { label: 'Accepted', class: 'bg-success-subtle text-success-emphasis' },
    note: 'Accepted by audit team.'
  },
  {
    ref: 'RFI-019',
    requested: 'Deviation register and committee ratifications',
    area: 'Supply chain management',
    requested_by: 'Internal Audit',
    owner: 'SCM Manager',
    due: '25 Apr 2026',
    status: { label: 'Accepted', class: 'bg-success-subtle text-success-emphasis' },
    note: 'Accepted and mapped.'
  }
];

export const finding_category_options = [
  'Supply chain management',
  'Predetermined objectives',
  'Financial statements',
  'Compliance with legislation',
  'Consequence management',
  'IT controls',
  'Internal control'
];

export const finding_rating_options = ['Material', 'Significant', 'Moderate', 'Minor', 'Admin'];
export const finding_status_options = ['Open', 'Management response', 'In progress', 'Internal audit review', 'Resolved', 'Closed'];

export const findings_cards = [
  { label: 'Findings', value: '6', note: 'Total raised', accent: 'dark' },
  { label: 'Material / significant', value: '4', note: 'High severity', accent: 'red' },
  { label: 'Repeat findings', value: '2', note: 'Recurring', accent: 'red' },
  { label: 'Closed', value: '0', note: 'Cleared by IA', accent: 'green' }
];

export const findings_rows = [
  {
    ref: 'AFS-2026-001',
    finding: 'RFQ evaluation records not retained for two awards',
    category: 'Supply chain management',
    owner: 'SCM Manager - T. Mbatha',
    due: '30 Jun 2026',
    rating: 'Material',
    status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' },
    repeat: true
  },
  {
    ref: 'AFS-2026-002',
    finding: 'Privileged access not reviewed for April',
    category: 'IT controls',
    owner: 'CISO - R. Govender',
    due: '20 Jun 2026',
    rating: 'Significant',
    status: { label: 'Management response', class: 'bg-info-subtle text-info-emphasis' },
    repeat: false
  },
  {
    ref: 'AFS-2026-004',
    finding: 'Performance information not supported by evidence',
    category: 'Predetermined objectives',
    owner: 'Strategy and M&E - L. Adams',
    due: '10 Jul 2026',
    rating: 'Significant',
    status: { label: 'Open', class: 'bg-danger-subtle text-danger-emphasis' },
    repeat: false
  },
  {
    ref: 'AFS-2026-006',
    finding: 'Operator processing personal data without signed DPA',
    category: 'Compliance with legislation',
    owner: 'Information Officer - P. Naidoo',
    due: '12 Jul 2026',
    rating: 'Significant',
    status: { label: 'Open', class: 'bg-danger-subtle text-danger-emphasis' },
    repeat: false
  },
  {
    ref: 'AFS-2026-003',
    finding: 'Supplier paid with expired tax clearance (blocked)',
    category: 'Compliance with legislation',
    owner: 'Procurement - T. Mbatha',
    due: '15 Jun 2026',
    rating: 'Moderate',
    status: { label: 'Internal audit review', class: 'bg-info-subtle text-info-emphasis' },
    repeat: true
  },
  {
    ref: 'AFS-2026-005',
    finding: 'Conflict-of-interest declaration outstanding for bid member',
    category: 'Consequence management',
    owner: 'HR - N. Dlamini',
    due: '20 Jun 2026',
    rating: 'Moderate',
    status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' },
    repeat: false
  }
];

export const create_engagement_form = () => ({
  name: '',
  type: 'External (AGSA)',
  status: 'Planning',
  auditor: '',
  lead_contact: '',
  period: '',
  fieldwork_dates: '',
  prior_outcome: '',
  target_outcome: '',
  readiness: 50,
  scope_areas: '',
  scope_notes: '',
  evidence_focus: ''
});

export const create_request_form = () => ({
  requested: '',
  audit_ref: 'AUD-01',
  area: '',
  requested_by: 'AGSA',
  owner: '',
  due: '',
  status: 'Requested',
  note: ''
});

export const create_finding_form = () => ({
  title: '',
  audit_ref: 'AUD-01',
  category: 'Supply chain management',
  rating: 'Moderate',
  status: 'Open',
  finding: '',
  criteria: '',
  cause: '',
  effect: '',
  recommendation: '',
  management_response: '',
  owner: '',
  accountable: '',
  due: '',
  repeat: 'No'
});

const request_status_class_map = {
  Insufficient: 'bg-danger-subtle text-danger-emphasis',
  'In progress': 'bg-warning-subtle text-warning-emphasis',
  Submitted: 'bg-info-subtle text-info-emphasis',
  Accepted: 'bg-success-subtle text-success-emphasis'
};

const finding_status_class_map = {
  Open: 'bg-danger-subtle text-danger-emphasis',
  'In progress': 'bg-warning-subtle text-warning-emphasis',
  'Management response': 'bg-info-subtle text-info-emphasis',
  'Internal audit review': 'bg-info-subtle text-info-emphasis',
  Resolved: 'bg-success-subtle text-success-emphasis',
  Closed: 'bg-success-subtle text-success-emphasis'
};

export const request_status_class = (label) => Reflect.get(request_status_class_map, label) || 'bg-light text-secondary border border-light';
export const finding_status_class = (label) => Reflect.get(finding_status_class_map, label) || 'bg-light text-secondary';
